import { env } from '$env/dynamic/public';

/**
 * Cloudflare Turnstile site key, shared by the contact form and the chat.
 *
 * **Public by design.** It is served in the page source to every visitor, and it
 * names a widget rather than granting access to anything — the half that has to
 * stay secret is `TURNSTILE_SECRET`, which lives only in `wrangler secret put`
 * and is read by `verifyTurnstile` in `src/worker.ts`.
 *
 * **The committed default is the point**, exactly as for `GA_MEASUREMENT_ID` in
 * `$lib/seo/config` and `OMISE_PUBLIC_KEY` in `$lib/checkout/config`. With the
 * value living only in a gitignored `.env`, any build from another checkout or
 * machine — CI included, which never has that file — silently produced a site
 * with no challenge. That is not a degraded site but a broken one: the two halves
 * each decide independently whether there is a challenge, so a build with no key
 * renders none, never obtains a token, and is then rejected by a Worker that
 * requires one. Every chat message answered "Something went wrong" and every
 * contact form send failed, from the moment the secret was set on 22 August 2026
 * until the key was committed here.
 *
 * `$env/dynamic/public` rather than static so an absent variable is not a build
 * error, leaving `PUBLIC_TURNSTILE_SITE_KEY` as an override for a checkout that
 * needs a different widget. The site is fully prerendered, so this resolves on
 * the build machine and is baked in: changing it needs a rebuild, not a redeploy.
 *
 * Empty disables the challenge on both forms. Only ever pair that with an unset
 * `TURNSTILE_SECRET` — `scripts/check-env.mjs` fails the build if you do not.
 */
export const TURNSTILE_SITE_KEY = env.PUBLIC_TURNSTILE_SITE_KEY || '0x4AAAAAAEVYiUYiKYfQMO4k';
